import { organizationQuery } from "@/query/organization.query";
import { OrganizationDetailView } from "@/routes/common/orgnizationDetail";
import { toNumber } from "@/utils/mapping";
import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs, redirect, useLoaderData } from "react-router-dom";

export function loader(queryClient: QueryClient) {
  return async ({ params }: LoaderFunctionArgs) => {
    const id = toNumber(params["id"]);
    if (id === null) {
      throw redirect("/error/404");
    }
    const organization = await queryClient.fetchQuery(organizationQuery(id));
    if (!organization) {
      throw redirect("/error/404");
    }
    return { organization };
  };
}

export const OrganizationDetailPage = () => {
  const data = useLoaderData() as Awaited<ReturnType<ReturnType<typeof loader>>>;
  return <OrganizationDetailView organization={data.organization} />;
};
